
export const formateDate = (date) => {
  return date.getFullYear() + '-' +
    (((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '-' +
    ((date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())) + ' ' +
    ((date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())) + ':' +
    ((date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())) + ':' +
    ((date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds()))
}

// downJumpConfirm.call() to bind this 跳转下载中心confirm
export const downJumpConfirm = function () {
  this.$confirm('正在导出，可到下载中心 下载报表文件。', {
    center: true,
    confirmButtonText: '去下载中心',
    cancelButtonText: '留在此页'
  }).then(() => {
    this.$store.dispatch('delVisitedViews', {
      path: '/fileManage/downloadCenter'
    }).then(() => {
      this.$router.push('/fileManage/downloadCenter')
    })
  }).catch(() => {

  })
}

// 下载文件，默认文件类型为excel
export function createDownLink (data, fileName, type = 'application/vnd.ms-excel;charset=utf-8') {
  const blob = new Blob([data], {
    type: type
  })
  if ('download' in document.createElement('a')) { // 非IE下载
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  } else { // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}

// 8-20位大小写字母、数字、符号中的至少三种组合登录密码
export function validStrictPsd (str) {
  const reg = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z_\W]+$)(?![a-z\d]+$)(?![a-z_\W]+$)(?![\d_\W]+$)[^\u4e00-\u9fa5\s]{8,20}$/
  return reg.test(str)
}
export const strictPsdError = '密码为8-20位大写/小写字母/数字/符号中的至少三种组合'

export function getH5Domain () {
  if (process.env.NODE_ENV === 'production') {
    if (process.env.CUSTOM_ENV === 'test') {
      return 'https://t-h5.lepass.cn/' // 测试环境
    } else if (process.env.CUSTOM_ENV === 'pre') {
      return 'https://p-h5.lepass.cn/' // 预发布环境
    } else if (process.env.CUSTOM_ENV === 'prd') {
      return 'https://h5.leshuazf.com/' // 正式环境
    }
  } else {
    return 'https://t-h5.lepass.cn/'
  }
}
export const deepClone = (source) => {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
export const swap = (arr, i, j) => {
  [arr[i], arr[j]] = [arr[j], arr[i]]
}
export const random = (min, max) => {
  if (min > max) {
    min = [max, (max = min)][0]
  }
  const range = max - min
  return min + Math.round(Math.random() * range)
}
export const arrSum = function (arr) {
  return arr.reduce((x, y) => x + y)
}
export const formatFloat = function (num, x = 2) {
  if (!num) {
    num = 0
  } else if (typeof num !== 'number') {
    num = Number.parseFloat(num)
  }
  return Number.parseFloat(Number.parseFloat(num).toFixed(x))
}
/**
 * @desc 函数防抖
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
export const debounce = function (func, wait, immediate) {
  var time
  const debounced = function () {
    const context = this
    // console.log("time:", time);
    if (time) {
      clearTimeout(time)
    }

    if (immediate) {
      const callNow = !time
      if (callNow) func.apply(context, arguments)
      time = setTimeout(() => {
        func.apply(context, arguments)
        time = null
      }, wait)
    } else {
      // console.log("exe");
      time = setTimeout(() => {
        func.apply(context, arguments)
      }, wait)
    }
  }

  debounced.cancel = function () {
    clearTimeout(time)
    time = null
  }

  return debounced
}

export const throttle = function (func, wait) {
  let previous = 0
  return function () {
    const now = Date.now()
    const context = this
    const args = arguments
    if (now - previous > wait) {
      func.apply(context, args)
      previous = now
    }
  }
}
export const isJSON = function (str) {
  if (typeof str === 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      console.log('error：' + str + '!!!' + e)
      return false
    }
  }
  console.log('It is not a string!')
}
export const getWeek = function (date) {
  const a = ['日', '一', '二', '三', '四', '五', '六']
  const week = date.getDay()
  return `周${a[week]}`
}

export const formatDuration = function (s, isSymbol = false) {
  const unitFormat = isSymbol ? ['°', '′', '″'] : ['时', '分', '秒']

  s = Number.parseFloat(s) || 0
  if (s < 0) {
    s = 0
  }
  s = Math.ceil(s)
  const m = Math.floor(s / 60)
  if (m > 0) {
    const remainS = s % 60
    const h = Math.floor(m / 60)
    if (h > 0) {
      const remainM = m % 60
      return `${h}${unitFormat[0]}${remainM}${unitFormat[1]}${remainS}${unitFormat[2]}`
    } else {
      return `${m}${unitFormat[1]}${remainS}${unitFormat[2]}`
    }
  } else {
    return `${s}${unitFormat[2]}`
  }
}

export const safariDate = function (dateStr) {
  return dateStr.replace(/-/g, '/')
}
export const dateFormat = function (date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) {
    return ''
  }
  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/'))
  }
  if (typeof date === 'number') {
    date = new Date(date)
  }
  var o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours() % 24 === 0 ? 24 : date.getHours() % 24,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  }
  var week = {
    0: '\u65e5',
    1: '\u4e00',
    2: '\u4e8c',
    3: '\u4e09',
    4: '\u56db',
    5: '\u4e94',
    6: '\u516d'
  }
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? '\u661f\u671f'
          : '\u5468'
        : '') + week[date.getDay() + '']
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  console.log(fmt)
  return fmt
}
export function getUrlParam () { // URL取参方法
  const search = window.location.search
  const hash = window.location.hash
  const match1 = (search && search.match(/([^?=&]+)=([^?&]+)/g)) || []
  const match2 = (hash && hash.match(/([^?=&]+)=([^?&]+)/g)) || []
  const match = match1.concat(match2)
  return (
    match &&
    match.reduce(function (a, b) {
      const val = b.split(/([^?=&]+)=([^?&]+)/g)
      a[val[1]] = val[2]
      return a
    }, {})
  )
}
